// Smile EVO Pints panel was being blocked by cookies. This allows it to open even if cookies are denied.
  (() => {
    const SMILE_LOADER_PATH = '/assets/smile-loader.js';

    function loadSmileWhenBlocked() {
      const smileScripts = Array.from(document.querySelectorAll('script[src]'));

      const blockedSmileScript = smileScripts.find((script) => {
        return (
          script.src.includes(SMILE_LOADER_PATH) &&
          script.type === 'text/plain'
        );
      });

      if (!blockedSmileScript) return;

      if (document.querySelector('script[data-mr-smile-loader="true"]')) {
        return;
      }

      const smileLoader = document.createElement('script');

      smileLoader.src = blockedSmileScript.src;
      smileLoader.async = true;
      smileLoader.setAttribute('data-cookieconsent', 'ignore');
      smileLoader.setAttribute('data-mr-smile-loader', 'true');

      document.head.appendChild(smileLoader);
    }

    loadSmileWhenBlocked();

    const observer = new MutationObserver(loadSmileWhenBlocked);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.addEventListener('load', loadSmileWhenBlocked);
  })();